import React, { useState, useEffect } from "react";
import CustomTable from "../../../components/table/table";
import "./view.css";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import {
  admin_challenge_opportunity_delete,
  get_challenge_opportunity_list,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const onSearch = () => {
    //
  };
  const handleChallengeOpportunityList = async () => {
    setIsActive(true);
    try {
      const res = await get_challenge_opportunity_list();
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
            ...item,
            slno: index + 1,
            opportunity:
              item?.market_analysis_opportunity?.opportunity ??
              item?.market_analysis_opportunity_name ??
              item?.opportunity ??
              "",
            status_code:
              String(item?.status).toLowerCase() === "pending" ||
              String(item?.status) === "0"
                ? 0
                : String(item?.status).toLowerCase() === "approved" ||
                  String(item?.status) === "1"
                ? 1
                : String(item?.status).toLowerCase() === "rejected" ||
                  String(item?.status).toLowerCase() === "reject" ||
                  String(item?.status) === "2"
                ? 2
                : item?.status,
            image:
              item?.image && assetBaseUrl
                ? `${assetBaseUrl}/${String(item.image).replace(/^\//, "")}`  
                : item?.image || "",
            brochure:
              item?.brochure && assetBaseUrl
                ? `${assetBaseUrl}/${String(item.brochure).replace(/^\//, "")}`
                : item?.brochure || "",
          }))
        : [];

      setData(tdata);
    } catch (error) {
      setData([]);
      setSnackMessage(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch challenge opportunity list"
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleChallengeOpportunityList();
  }, []);

  useEffect(() => {
    return () => {
      setData([]);
    };
  }, []);

  const handleEdit = (row) => {
    props.history.push({
      pathname: `/challenges-edit/${row.id}`,
      state: { row },
    });
  };

  const handleAddNew = () => {
    let path = "/challenges-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    props.history.push({
      pathname: `/challenges-view/${data.id}`,
      state: { row: data },
    });
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_challenge_opportunity_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to delete"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleChallengeOpportunityList();
    }
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Challenges</b>
        </h6>
        <hr />
        {/* --------------admin----- */}
        {adminType === 1 && (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                { title: "Image", field: "image", type: "imageFull" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]}
            />
          </>
        )}
        {/* ----------------- */}
        {/* --------------admin----- */}
        {adminType === 2 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                { title: "Image", field: "image", type: "imageFull" },  
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                { title: "Image", field: "image", type: "imageFull" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
              ]}
            />
          </>
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Challenge ?"
          data={activeData}
          message="Are you sure to Delete this Challenge?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
